import "antd/dist/antd.less";
import React, { useMemo, useEffect, useState, useRef } from "react";
import { Divider, Select, Menu, Layout, Button } from "antd";
import "./styles.less";
import { Link, useNavigation, useNavigate } from "react-router-dom";
import { css } from "@emotion/react";
import favicon from "/favicon.png";
import PreviewContent from './components/PreviewContent'
import PreviewImage from "./components/PreviewImage";
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import { message } from "antd";
import {Header as PreviewHeader} from './components/Header.jsx'
import { getNavObj, processItem, findMenuItem, findFirstLevelKeyByUvId } from './util.js'
import useDocTitle from '@/hooks/useDocTitle.mjs'
import useApi from "./useApi.mjs";
import { findFirstUI } from "./util.js";
import parseMap from '@/components/SoftwareMap/scripts/parseMap.mjs';
import { ArrowsAltOutlined } from '@ant-design/icons';
import openWindow from '@/script/openWindow.mjs'


const cssLayoutHeader = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: 0,
});
const cssLayoutHeaderLeft = css({
  fontSize: 20,
  color: "#fff",
  padding: "0 15px",
  display: "flex",
  alignItems: "center",
  width: '300px',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});
const cssLayoutHeaderCenter = css({
  fontSize: 14,
  fontWeight: "bold",
  color: "#fff",
  padding: "0 15px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 12,
});
const cssLayoutHeaderRight = css({
  color: "#fff",
  flexGrow: "1",
  flexShrink: "0",
  flexBasis: 0,
  display: 'flex',
  justifyContent: 'end'
//   gap: 12,
});
const cssLink = css({
  fontWeight: "bold",
  color: "#fff",
  display: "flex",
  alignItems: "center",
});
const cssLogo = css({
  height: 22,
  marginRight: 8,
});
const cssDivider = css({
  borderColor: "#fff",
});

function processArray(arr) {
  let firstUVKey = null;


  function traverse(obj) {
    if (Array.isArray(obj)) {
      for (let item of obj) {
        traverse(item);
      }
    } else if (typeof obj === "object" && obj !== null) {
      if (obj.type === 'UM') {
        if (!obj.children || obj.children.length === 0) {
          obj.disabled = true;
        }
      } else if (obj.type === 'UI') {
        obj.uvId = obj.children?.[0]?.key || undefined;
        obj.demoType = obj.children?.[0]?.demoType || 'IMG';
        delete obj.children;
      }
      for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
              traverse(obj[key]);
          }
      }
    }
  }

  traverse(arr)

  return firstUVKey;
}

/**
 * @name 当ui层级只有一个的时候去除，并将数据保存到父节点，label与key分别转为uiName与uiId
 * @param {*} data 
 * @returns 
 */
function processData(data) {
  return data.map(item => {
    if (item.children) {
      const newChildren = [];
      const uiChildren = [];
      
      // 分类子节点
      item.children.forEach(child => {
        if (child.custom?.type === 'UI') {
          uiChildren.push(child);
        } else {
          // 递归处理非UI子节点
          const processedChild = processData([child])[0];
          if (processedChild) {
            newChildren.push(processedChild);
          }
        }
      });
      
      // 只有当UI类型子节点只有一个时才处理
      if (uiChildren.length === 1) {
        const uiChild = uiChildren[0];
        // 将UI信息添加到父节点的custom中
        item.custom = {
          ...item.custom,
          uiId: uiChild.key,
          uiName: uiChild.label,
          uiCustom: { ...uiChild.custom }
        };
      } else if (uiChildren.length > 1) {
        // 多个UI子节点，保留它们
        newChildren.push(...uiChildren);
      }
      
      item.children = newChildren.length > 0 ? newChildren : undefined;
    }
    
    return item;
  });
}

const Header = ({ current, uvObj, menuData = [], setScaleNum, handleMenuChange, showUvName }) => {
  // const [current, setCurrent] = useState(typeList[0].items[0].key);
  const [frameKey, setFrameKey] = useState()
  const [loading, setLoading] = useState(false)
  const items = menuData.find((item) => item.key == frameKey)?.children?.map(processItem) || []
  const newItems = processData(items)
  useEffect(() => {
    // menuData为空数组的时候return
    if (!menuData.length) return;

    const localFrameKey = localStorage.getItem('formilyPreviewFrameKey')
    const activeFrameKey = findFirstLevelKeyByUvId(menuData, current)
    let newFrameKey;
    if(activeFrameKey) {
      newFrameKey = activeFrameKey;
    }else {
      const allKeys = menuData.map(item => item.key)
      if(!allKeys.includes(localFrameKey)) {
        newFrameKey = allKeys[0]
      } else {
        newFrameKey = localFrameKey
      }
    }
    setFrameKey(newFrameKey)
    localStorage.setItem(
      'formilyPreviewFrameKey',
      newFrameKey
    )
  }, [menuData])

  const handleChange = (val) => {
    setScaleNum(val);
  };

  const handleMenuClick = (e) => {
    const targetItem = findMenuItem(items, e.key)
    const customData = targetItem?.custom || {};
    handleMenuChange(customData.uiId, {
      key: customData.uiId,
      uvId: customData.uiCustom?.uvId,
    })
  };

  const handleFrameKeyChange = (key) => {
    if (key == frameKey) return;
    setLoading(true)
    const items = menuData.find(item => item.key == key);
    const firstUVKey = findFirstUI(items);
    if (!firstUVKey) {
      message.warning(`${items.label}没有可用的视图`)
      setLoading(false)
      return;
    } else {
      handleMenuChange(firstUVKey.key, {
        key: firstUVKey.key,
        uvId: firstUVKey.uvId,
      })
    }
    localStorage.setItem(
      'formilyPreviewFrameKey',
      key
    )
    setFrameKey(key)
    setTimeout(()=> {
      setLoading(false)
    }, 200)
  }

  return (
    <Layout.Header css={cssLayoutHeader}>
      <div css={cssLayoutHeaderLeft}>
        <Link css={cssLink} reloadDocument to="/" title={"进入工作台"}>
          <img css={cssLogo} alt="logo" src={favicon} />
          软件逻辑地图
        </Link>
        <Divider type="vertical" css={cssDivider} />
        <span style={{ fontSize: 14, fontWeight: "bold" }}>界面看板</span>
      </div>

      <div css={cssLayoutHeaderCenter}>
        {menuData && menuData.length > 0 && <Select
          value={frameKey}
          dropdownMatchSelectWidth={false}
          style={{ width: 180 }}
          options={menuData.map((item) => ({
            value: item.key,
            label: item.label,
          }))}
          onChange={handleFrameKeyChange}
        ></Select>}
        <span title={uvObj.uvName} className="header_uvname">
          {uvObj.uiName && `${uvObj.uiName}`} {showUvName && `（${uvObj.uvName}）`}
        </span>

        {uvObj.uvType == "MOBILE" && (
          <Select
            defaultValue={1}
            bordered={false}
            style={{ color: "#fff", width: 58 }}
            showArrow={false}
            size="small"
            onChange={handleChange}
            options={[
              {
                value: 0.35,
                label: "35%",
              },
              {
                value: 0.5,
                label: "50%",
              },
              {
                value: 0.8,
                label: "80%",
              },
              {
                value: 1,
                label: "100%",
              },
              {
                value: 1.2,
                label: "120%",
              },
              {
                value: 1.5,
                label: "150%",
              },
              {
                value: 2,
                label: "200%",
              },
            ]}
          />
        )}
      </div>

      <div css={cssLayoutHeaderRight}>
        {!loading && <Menu
          style={{ width: '200px', flexGrow: 1, justifyContent: "flex-end" }}
          theme="dark"
          activeKey={frameKey}
          onClick={handleMenuClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={newItems?.map(item => ({label: item.label, key: item.key, children: item.children, disabled: item.disabled, custom: item.custom}))}
        />}
      </div>
    </Layout.Header>
  );
};

const FormilyFrame = (props) => {
  const params = new URLSearchParams(location.search.split("?")[1]);
  const uvMode =  params.get("uvMode") ? Number(params.get("uvMode")) : 2;
  const isTemplate = uvMode != 2;
  const [uvObj, setUvObj] = useState({});
  const [current, setCurrent] = useState(null);
  const [showUvName, setShowUvName] = useState(false);
  const [currentType, setCurrentType] = useState('IMG')
  const [shcemaData, setSchemaData] = useState({});
  const http = useHTTP();
  const api = useApi();
  const [menuData, setMenuData] = useState([])

  const [scaleNum, setScaleNum] = useState(1);
  const navigation = useNavigation();
  const navigate = useNavigate();
  useDocTitle('界面看板');

  const [position, setPosition] = useState({ x: 8, y: 68 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const buttonRef = useRef(null);

  const handleToUiMap = () => {
    const _params = new URLSearchParams(location.search.split("?")[1]);
    openWindow('/UiDetail', { uiId:uvObj.uiId || _params.get("uiId")}, '_blank')
  }

  // 处理鼠标按下事件
  const handleMouseDown = (e) => {
    if(buttonRef.current) {
      setIsDragging(true);
      const rect = buttonRef.current.getBoundingClientRect();
      setDragOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      });
      e.preventDefault();
    }
  };

  // 处理鼠标移动事件
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const container = document.querySelector('.formilyFrame');
    const containerRect = container.getBoundingClientRect();
    const buttonRect = buttonRef.current.getBoundingClientRect();
    
    // 计算新位置，限制在容器范围内
    let newX = containerRect.right -e.clientX - dragOffset.x;
    let newY = e.clientY - dragOffset.y - containerRect.top;
    
    // 边界检查
    newX = Math.max(0, Math.min(containerRect.width - buttonRect.width, newX));
    newY = Math.max(0, Math.min(containerRect.height - buttonRect.height, newY));
    
    setPosition({ x: newX, y: newY });
  };

  // 处理鼠标释放事件
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // 添加全局事件监听
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, dragOffset]);

  const handlePopState = (event) => {
    if (event.state) {
       const uvId = params.get('uvId');
       const uiId = params.get('uiId');
       if(uvId && uvId != 'undefined'){
         handleFetchData(uvId, true)
       }
       if (uiId && uiId != 'undefined') {
          fetchUIData(uiId, true)
       }
    }
  };
  useEffect(() => {
    if (navigation.state === 'idle') {
      handlePopState(navigation)
    }
  }, [navigation.state]);

  useEffect(() => {
    doQuery()
  }, [])

  const doQuery = () => {
    const prjId = params.get('prjId');
    const sVer = params.get('sVer') || 1;
    const uvId = params.get('uvId');
    const uiId = params.get('uiId');
    if(!uvId && !uiId && !prjId) {
      return message.warning(`请选择项目`);
    }
    if(prjId) {
      handleFetchMenu({ prjId, sVer }, !uvId && !uiId)
    }
    if(uvId) {
      handleFetchData(uvId)
    }
    if(!uvId && uiId) {
      fetchUIData(uiId, true)
    }
  }

  // 若是存在uvId 获取视图map信息
  const handleFetchData = async (uvId, isNext=true) => { 
    try {
      const data = await api.fetchUmUv({ pkid: uvId });
      if (data) {
        setSchemaData(data)
        const { demoType, prjId, sVer } = data;
        const fileIdData = data?.demoMap && JSON.parse(data?.demoMap)
          ? parseMap(data?.demoMap)[0]
          : undefined;
        const fileId = fileIdData?.data?.fileId;
        setUvObj({
          uvType: data.uvType,
          uvName: data.uvName,
          fileId,
          uiId: data.uiId,
          uiName: data.uiName
        });
        setCurrentType(demoType)
        setCurrent(data.uiId)
        
        // if (isFirst) {
        //   handleFetchMenu({
        //     prjId,
        //     sVer,
        //   });
        // }
        if(isNext && data.uiId != current) fetchUIData(data.uiId);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleFetchMenu = async (params, isFirst=false) => {
    if (!params.prjId) return;
    const data = await runAsync(
        async () => {
            return await api.loadTreeMenu(params);
        },
        {
            error: {content: (err) => `查询菜单失败: ${err.message}`},
            loading: {show: false},
            success: {show: false},
        }
    );
    if (data && data.length > 0) {
        processArray(data)
        // const firstUVKey = findFirstUI(data[0])
        let i = 0;
        let firstUVKey;
        while (i < data.length && !firstUVKey) { 
          firstUVKey = findFirstUI(data[i])
          i++;
        }
        if (!firstUVKey) {
          message.warning(`该项目没有可用的视图`)
        } else if (isFirst) {
          if(firstUVKey.uvId) {
            handleFetchData(firstUVKey.uvId)
          }else if(firstUVKey.type == 'UI' && firstUVKey.key) {
            fetchUIData(firstUVKey.key, true)
          }
        }

        setMenuData(data);
    }
  }

  // 获取当前用户界面的子视图是否大于1，来判断是否显示视图名称
  const fetchUIData = async (id, isNext=false) => {
    if(!id) return;
    const prjId = params.get('prjId');
    // if(!prjId) return;
    const data = await api.fetchUiById({pkid: id});
    if(data) {
      const uiMap = JSON.parse(data?.uiMap)?.root?.children || [];
      const uidemo = uiMap.find(item => item.bizNodeType == 'UI_DEMO')?.children || [];
      setShowUvName(uidemo.length > 1)
      if(!uidemo.length) {
        setUvObj({
          uvType: data.uvType,
          uvName: data.uvName,
          fileId: undefined,
          uiId: data.pkid,
          uiName: data.uiName,
          prjId: data.prjId,
          sVer: data.sVer
        });
        setCurrentType('IMG')
        setCurrent(data.pkid)
        return
      };
      const uvData = uidemo[0];

      if(isNext) {
        handleFetchData(uvData.pkid, false)
      }
    }
  };

  const handleMenuChange = (id, option) => {
    // const iframeWindow = iframeRef.contentWindow
    setCurrent(id)
    let navObj = {};
    const uvId = option.uvId
    if(!!uvId) {
      navObj = getNavObj({uvId})
    }else {
      navObj = getNavObj({ uiId: id})
    }
    navigate(navObj);
  }



  return (
    <div className="formilyFrame" >
        {
            params.get('prjId') ? 
            <Header
                current={current}
                setScaleNum={setScaleNum}
                menuData={menuData}
                showUvName={showUvName}
                uvObj={uvObj}
                handleMenuChange={handleMenuChange}
            />: 
            <PreviewHeader
                setScaleNum={setScaleNum}
                isTemplate={isTemplate}
                uvObj={uvObj}
            />
        }
      
      {currentType == "IMG" ? (
        <PreviewImage current={current} uvObj={uvObj} />
      ) : (
        <PreviewContent
          current={current}
          uvObj={uvObj}
          shcemaData={shcemaData}
          uvType={currentType}
          scaleNum={scaleNum}
        />
      )}
      <div
        ref={buttonRef}
        className="draggable-btn"
        style={{
          right: `${position.x}px`,
          top: `${position.y}px`,
          cursor: isDragging ? 'grabbing' : 'grab'
        }}
        // onMouseDown={handleMouseDown}
      >
        <Button 
          // shape="circle" 
          // icon={<ArrowsAltOutlined />} 
          size="small"
          onClick={handleToUiMap}
        >
          查看逻辑图
        </Button>
      </div>
    </div>
  );
};

export default FormilyFrame;
